class LoadingIndicatorController {
  constructor($scope) {
      "ngInject";
      this.name = 'loadingIndicator';
      this.scope = $scope;
  }
}

export default LoadingIndicatorController;



// WEBPACK FOOTER //
// ./client/common/loadingIndicator/loadingIndicator.controller.js